import { Skeleton, Typography } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

const ViewContractSkeleton = () => {
    return (
        <>
            <Skeleton width={250} height={40} />
            {/* contract section */}
            <div className="overflow-y-auto p-4 mt-6 bg-white border-2 border-dashed border-[#D7DBEC] h-full max-h-[240px] rounded-[5px]">
                <Typography sx={{ display: "flex", justifyContent: "center", alignItems: "center", alignSelf: "center", height: "100%" }}>
                    در حال دریافت قرارداد
                    <CircularProgress sx={{ marginRight: "7px", color: "#BBA57A" }} size={24} />
                </Typography>
            </div>

            {/* btns for sign and download contract */}
            <div className="mt-4 button-container">
                <Skeleton width={'100%'} height={40} />

                <Skeleton width={'100%'} height={40} />
            </div>
        </>
    );
};

export default ViewContractSkeleton;
